//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { compare } from '@/common/utils/index.js'
export default {
  name: 'news',
  data() {
    return {
      newsTitle: ['充值信息', '维护信息', '异常通知', '优惠通知', '获奖通知', '首页公告', '首页推荐'],
      newsLists: []
    }
  },
  props: {
    publishInfo: {
      type: Array,
    }
  },
  watch: {
    publishInfo() {
      this.setInfoList()
    }
  },
  methods: {
    closeNews() {
      this.$emit('close', false)
    },
    setInfoList() {
      this.$t('newsTitle').forEach((item, index) => {
        let list = this.publishInfo.filter((ite) => (ite.type === index + 1))
        if (list.length > 0) this.newsLists.push({ titles: item, type: index + 1, list })
      })
      this.newsLists = this.newsLists.sort(compare('type', false))
    }
  },
  mounted(){
    this.setInfoList()
  }
}



// WEBPACK FOOTER //
// ./src/pages/build800/components/base/home/news.vue